<app-prev-next-button (click)="goBack()" *ngIf="back" direction="left" [label]="back.label"></app-prev-next-button>
<h1>{{title}}</h1>
<app-prev-next-button (click)="goForward()" *ngIf="forward" direction="right" [label]="forward.label"></app-prev-next-button>
